import React from 'react';
import { EDUCATION } from '../../data/portfolio';

const Education: React.FC = () => (
  <div className="page">
    <header>
      <h2>
        education <span>{EDUCATION.length}</span>
      </h2>
      <p>Degrees and coursework that shaped how I build systems.</p>
    </header>
    <div className="tl">
      {EDUCATION.map((edu) => (
        <article key={edu.id} className="tl-item">
          <div className="tl-meta">
            <span className="tl-dates">{edu.dates}</span>
          </div>
          <div className="tl-body">
            <div className="tl-head">
              {edu.logo && (
                <img className="tl-logo" src={edu.logo} alt="" aria-hidden="true" />
              )}
              <div>
                <h3>{edu.degree}</h3>
                <p className="tl-org">
                  {edu.school} · {edu.location}
                </p>
              </div>
            </div>
            {edu.detail && <p className="tl-detail">{edu.detail}</p>}
            {edu.highlights && edu.highlights.length > 0 && (
              <ul className="tl-bullets">
                {edu.highlights.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
            )}
          </div>
        </article>
      ))}
    </div>
  </div>
);

export default Education;
